import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      // Redirigir según el rol del usuario
      // Esperar un momento para que el estado se actualice
      setTimeout(() => {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (user.rol === 'operador') {
          navigate('/documentos');
        } else {
          navigate('/dashboard');
        }
      }, 100);
    } catch (err: any) {
      console.error('Error en login:', err);
      const errorMessage = err.response?.data?.error || err.message || 'Error al iniciar sesión';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img 
            src="/logo_enerpetrol.png" 
            alt="Enerpetrol Logo" 
            className="login-logo"
            onError={(e) => {
              console.error('Error loading logo:', e);
              // Intentar con extensión en mayúsculas como fallback
              if (e.currentTarget.src !== '/logo_enerpetrol.PNG') {
                e.currentTarget.src = '/logo_enerpetrol.PNG';
              }
            }}
          />
          <p>Sistema de gestion</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@enerpetrol.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>

        <div className="login-footer">
          <p>Sistema de Gestión de Operadores Enerpetrol © 2025</p>
        </div>
      </div>
    </div>
  );
};

export default Login;

